import styled from "styled-components";
import { BrightCTAColor, CTAColor } from "../../styles/styles";
import { Flex } from "../../common/Layouts/styles";

export const EthnosContainer = styled(Flex)`
  background-color: ${BrightCTAColor};
  position: relative;
  z-index: 0;
  margin-top: 2vw;
  overflow: hidden;
  padding: 2vw 2.4vw;
`;

export const AbsoluteSphere = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const CenterText = styled(Flex)`
  width: 100%;
  padding-top: 7vw;
  padding-bottom: 2vw;
`;

export const Mission = styled(Flex)`
  color: black !important;
`

export const BottomText = styled(Flex)`
  width: 66.6%;
  padding-bottom: 7vw;
  padding-top: 2vw;
`;

export const TrTag = styled(Flex)`
  color: white;
  text-transform: uppercase;
  align-items: center;
  gap: .2vw;
  font-size: 1.35em;
`;

export const Plus = styled("span")`
  color: white;
  font-size: 2em;
  position: relative;
  bottom: .16vw;
`

export const MiddleText = styled("h4")`
  color: black !important;
  font-weight: 400;
`

export const ZIndex = styled(Flex)`
  position: relative;
  z-index: 2;

`

export const PixelSideText = styled("h2")`
  font-family: greyBeard;
  font-size: 5.6em;
  color: black;
  text-transform: uppercase;
`